import de from "@/translations/de.json";

const languages = {
  de: de
};

export default languages;
